import React from "react";
import { Form } from "semantic-ui-react";

export default function IncomeInput({
  incomeAmount,
  onIncomeChange,
  onSubmit,
}) {
  return (
    <div>
      <h3 style={{ marginBottom: "2px" }}>Verifiable Income</h3>
      <p>Customer's income per month</p>
      <Form size="large">
        <Form.Group style={{ display: "flex", alignItems: "center" }}>
          <Form.Input
            icon="dollar"
            onChange={onIncomeChange}
            value={incomeAmount}
            onBlur={onSubmit}
          />
        </Form.Group>
      </Form>
    </div>
  );
}

IncomeInput.defaultProps = {
  incomeAmount: "",
  incomeType: "month",
};
